import { render, staticRenderFns } from "./AdvantagesWidget.vue?vue&type=template&id=ed360984&"
import script from "./AdvantagesWidget.vue?vue&type=script&lang=js&"
export * from "./AdvantagesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\DIA-funsporthandel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed360984')) {
      api.createRecord('ed360984', component.options)
    } else {
      api.reload('ed360984', component.options)
    }
    module.hot.accept("./AdvantagesWidget.vue?vue&type=template&id=ed360984&", function () {
      api.rerender('ed360984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/widgets/AdvantagesWidget.vue"
export default component.exports